










































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component } from 'vue-property-decorator';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  GridIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { IUser, KbvFilter, UserSpecialType } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import { Util } from '@/utils/Util';

@Component({
  components: {
    'user-filter': UserFilterComponent,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    UserIcon,
    XIcon,
    GridIcon,
  },
})
export default class KbvFilterComponent extends mixins(FilterMixin) {
  filter: KbvFilter = {
    users: [],
  };

  get isDefaultFilter() {
    return this.filter.users?.length === 0;
  }

  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      users: [],
    };
    this.updateFilter();
    this.$root.$emit('reset-kbv-filter');
  }

  get options() {
    return this.users.filter((user: IUser) => user.type === UserSpecialType.Kbv);
  }

  async mounted() {
    this.filter = await this.$store.getters['PreferencesModule/getKbvFilter'];
  }

  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }

    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setKbvFilter}`, this.filter);
    this.$root.$emit('update-kbv-filter', this.filter);
    this.close();
  }

  selectedFilterString() {
    let str = '';

    if (this.filter.users && this.filter.users.length > 0) {
      str += this.filter.users[0].firstname + ', ';
    }

    return str.substr(0, str.length - 2);
  }

  get isMobile() {
    return Util.isMobile();
  }
}
